import './SelectAudiences.pcss';
import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { FilterableMultiSelect } from '../../../../../common/components/FilterableMultiSelect/FilterableMultiSelect';
import { HandlerMethodTypes } from '@mm/utils';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import { StoreState } from '@mm/state/store-interfaces';

type OuterProps = {
  heading: string;
  disableDeleting: boolean;
  originalAudiences: number[];
  selectedAudiences: AudiencesModel[];
  onAudiencesSelected: (audiences: AudiencesModel[]) => void;
  showBadge?: boolean;
};
type StoreProps = ReturnType<typeof mapStateToProps>;
type ExternalProps = OuterProps & StoreProps;

type HandlerProps = ExternalProps;
type HandlerMethods = HandlerMethodTypes<HandlerProps, typeof handlers>;

type InnerProps = HandlerMethods;

type Props = InnerProps & ExternalProps;

const mapStateToProps = (state: StoreState) => ({
  audiences: state.audiences.entities,
});

const handlers = {
  onAudiencesSelected:
    ({ audiences, onAudiencesSelected }: HandlerProps) =>
    (selectedKeys: string[]) => {
      const selectedAudiences = audiences.filter(a =>
        selectedKeys.some(k => a.id.toString() === k),
      );
      if (selectedAudiences) {
        onAudiencesSelected(selectedAudiences);
      }
    },
};

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps),
  withHandlers(handlers),
);

const SelectAudiences = (props: Props) => {
  const {
    heading,
    selectedAudiences,
    audiences,
    onAudiencesSelected,
    disableDeleting,
    originalAudiences,
    showBadge,
  } = props;

  const items = audiences.map(a => ({ key: a.id.toString(), name: a.name }));
  const originalItems = originalAudiences.map(a => a.toString());

  if (selectedAudiences && audiences.length > 0) {
    return (
      <FilterableMultiSelect
        className="select-audiences"
        heading={heading}
        items={items}
        disableDeleting={disableDeleting}
        originalItems={originalItems}
        selectedKeys={selectedAudiences.map(a => a.id.toString())}
        onChange={onAudiencesSelected}
        showBadge={showBadge}
      />
    );
  }
  return <></>;
};

export default enhance(SelectAudiences);
